import { useLocation } from "react-router-dom";

const QueryStringUtils = () => {
	// A custom hook that builds on useLocation to parse
	// the query string for you.
	const useQuery = () => {
		return new URLSearchParams(useLocation().search);
	};

	// The debug switch -- ?debug=1 on the URL -- gating the debug panel, the
	// play data it shows and drive replay. Defined once here so they cannot
	// drift apart: a bare ?debug carries an empty value and does NOT count.
	const isDebug = (search) => !!new URLSearchParams(search).get("debug");

	// For components. Reads the router's location, so it re-evaluates when the
	// URL changes rather than only on mount.
	const useIsDebug = () => isDebug(useLocation().search);

	return {
		useQuery,
		isDebug,
		useIsDebug
	};
};

export default QueryStringUtils();
